// シナリオ編集に関する設定定数。
// fork_webapp_react の appConfig の既定値から、本アプリで必要な範囲だけを移植したもの。

// シナリオの最大作成数
export const MAX_SCENARIOS = 10
// 選択元となるプレイバックルートの最大数（一覧の件数表示用）
export const MAX_PLAYBACK_ROUTES = 30
// 荷積み/荷下ろしアクションと高さ保存マークの扱いを有効化するか
export const ENABLE_CARGO_TOGGLE = true

// スロット種別: 高さ保存マーク (cargo)
export const SLOT_TYPE_CARGO = 1

// 停止手順の停止秒数の上限（秒）。fork_webapp_react の MAX_WAIT_SEC と揃える
export const MAX_WAIT_SEC = 3600
// シナリオ編集で停止手順（停止（秒数指定）カード）を追加できるようにするか。
// fork_webapp_react の config.json `enableWaitStep`（既定 false）に対応する。
// false でも保存済みシナリオ内の停止手順は表示・秒数変更できる（追加だけ不可）
export const ENABLE_WAIT_STEP = false
